import React, { useEffect, useRef, useState } from 'react';

import FadeIn from '../FadeIn/FadeIn';

import './DesignCarousel.css';
// eslint-disable-next-line react/prop-types
const DesignCarouselDesktop = ({ images }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(1);
  const carouselItemsRef = useRef([]);
  const scrollToTop = useRef();
  const scrollRef = useRef();

  useEffect(() => {
    if (images && images[0]) {
      carouselItemsRef.current = carouselItemsRef.current.slice(
        0,
        // eslint-disable-next-line react/prop-types
        images.length,
      );

      setSelectedImageIndex(0);
      setSelectedImage(images[0]);
    }
  }, [images]);

  const handleSelectedImageChange = (newIdx) => {
    // eslint-disable-next-line react/prop-types
    if (images && images.length > 0) {
      setSelectedImage(images[newIdx]);
      setSelectedImageIndex(newIdx);
      scrollToTop?.current?.scrollTo(0, 0);
      if (scrollRef?.current) {
        scrollRef?.current?.scrollIntoView({
          inline: 'nearest',
          behavior: 'smooth',
        });
      }
    }
  };

  return (
    <div className="desktop-wrapper p-5">
      <div className="container-xl">
        <p ref={scrollRef}></p>
        <div className="pt-4 pb-5"></div>
        <div className="laptop-wrapper">
            <img alt="laptop" src="./images/laptop-2.png"/>
            <div className="mockup-data">
              <div className="mockup-scroll">
                <div ref={scrollToTop} className="mockup-scroll-wrap">
                  <div className="mockup-scroll-view">
                  <img alt="selected-image" className="selected-image-desktop" src={selectedImage?.url} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div className="carousel desktop pt-5">
          <FadeIn>
            <div className="carousel-images pb-3">
              {images &&
                images.map((desktopImages, idx) => (
                  <div
                    key={desktopImages.id}
                    className={`carousel-image-wrapper ${selectedImageIndex === idx ? 'carousel-image-selected' : ''}`}
                    onClick={() => handleSelectedImageChange(idx)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') handleSelectedImageChange(idx);
                    }}
                  >
                    <div
                      className="carousel-image desktop"
                      style={{
                        backgroundImage: `url(${desktopImages.url})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center top',
                        backgroundSize: 'cover',
                      }}
                      ref={(el) => (carouselItemsRef.current[idx] = el)}
                    />
                    <div className="carousel-caption">{desktopImages.name}</div>
                  </div>
                ))}
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  );
};

export default DesignCarouselDesktop;
